<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      id="modal-dispose"
      :title="$t('bloodBank.dispose-confirmation')"
      ok-variant="danger"
      :ok-only="true"
    >
      <p>{{ $t("bloodBank.dispose-confirmation-message") }}</p>
      <template #modal-footer="{}">
        <b-button
          variant="warning"
          @click="disposeBottle"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading" style="font-weight: bold">{{
            $t("bloodBank.dispose")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-revert-disposal"
      :title="$t('bloodBank.revert-disposal-confirmation')"
      ok-variant="warning"
      :ok-only="true"
    >
      <p>{{ $t("bloodBank.revert-disposal-confirmation-message") }}</p>
      <template #modal-footer="{}">
        <b-button
          variant="success"
          @click="revertDisposal"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading" style="font-weight: bold">{{
            $t("bloodBank.revert-disposal")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('bloodBank.add-boold-boottle')
          : $t('bloodBank.edit-boold-boottle')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group
              :label="$t('bloodBank.bottle-identifier')"
              label-for="bottle_identifier"
              style="font-weight: bold"
            >
              <b-form-input
                v-model="EditForm.bottle_identifier"
                :placeholder="$t('bloodBank.bottle-identifier')"
                style="font-weight: bold"
              />
              <p class="text-danger mt-1">{{ errorForm.bottle_identifier }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.abo')"
              label-for="abo"
              style="font-weight: bold"
            >
              <v-select
                v-model="EditForm.abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
              <p class="text-danger mt-1">{{ errorForm.abo }}</p>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.rh')"
              label-for="rh"
              style="font-weight: bold"
            >
              <v-select
                v-model="EditForm.rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
              <p class="text-danger mt-1">{{ errorForm.rh }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('bloodBank.inserted-at')"
              label-for="inserted_at"
              style="font-weight: bold"
            >
              <b-form-datepicker
                v-model="EditForm.inserted_at"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
            <p class="text-danger mt-1">{{ errorForm.inserted_at }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.prod-date')"
              label-for="production_date"
              style="font-weight: bold"
            >
              <b-form-datepicker
                v-model="EditForm.production_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>

            <p class="text-danger mt-1">{{ errorForm.production_date }}</p>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('bloodBank.exp-date')"
              label-for="expiration_date"
              style="font-weight: bold"
            >
              <b-form-datepicker
                v-model="EditForm.expiration_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>

            <p class="text-danger mt-1">{{ errorForm.expiration_date }}</p>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('bloodBank.filter-blood-store')">
      <div>
        <b-row class="mt-3">
          <b-col md="4" cols="6">
            <b-form-group
              :label="$t('bloodBank.bottle-identifier')"
              label-for="bottle_identifier"
              style="font-weight: bold"
            >
              <b-form-input
                v-model="bottle_identifier"
                :placeholder="$t('bloodBank.bottle-identifier')"
                style="font-weight: bold"
              />
            </b-form-group>
          </b-col>
          <b-col md="2" cols="4">
            <b-form-group
              :label="$t('bloodBank.abo')"
              label-for="abo"
              style="font-weight: bold"
            >
              <v-select
                v-model="abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="4">
            <b-form-group
              :label="$t('bloodBank.rh')"
              label-for="rh"
              style="font-weight: bold"
            >
              <v-select
                v-model="rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="4">
            <b-form-group
              :label="$t('bloodBank.status')"
              label-for="status"
              style="font-weight: bold"
            >
              <v-select
                v-model="status"
                :options="statusOptions"
                placeholder="available, dispensed, disposed"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-3">
          <b-col md="4" cols="6">
            <b-form-group
              :label="$t('bloodBank.search-from-to-by')"
              label-for="rh"
              style="font-weight: bold"
            >
              <v-select
                v-model="searchDate"
                :options="searchFromToBy"
                placeholder="Search From To By"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="6">
            <b-form-group
              v-if="selectedSearch.key"
              :label="$t(`${selectedSearch.label || ''} From`)"
              label-for="production_date"
              style="font-weight: bold"
            >
              <b-form-datepicker
                v-model="from_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group
              v-if="selectedSearch.key"
              :label="$t(`${selectedSearch.label || ''} To`)"
              label-for="expiration_date"
              style="font-weight: bold"
            >
              <b-form-datepicker
                v-model="to_date"
                :placeholder="$t('common.select-date')"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                locale="en"
                class="dark-datepicker"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mb-2 mt-1">
          <b-col md="3" cols="3" v-for="balance in balances" :key="balance.abo">
            <div class="text-center d-flex flex-column">
              <h1 style="font-weight: bolder">{{ balance.abo }}</h1>
              <h5 style="margin-bottom: 5px; font-weight: bold">
                {{ $t("lab.positive") }}:
                <b-badge
                  variant="primary"
                  style="font-size: 1.2rem; font-weight: bold"
                >
                  {{ balance.Positive }}</b-badge
                >
              </h5>
              <h5 style="font-weight: bold">
                {{ $t("lab.negative") }}:
                <b-badge
                  variant="primary"
                  style="font-size: 1.2rem; font-weight: bold"
                >
                  {{ balance.Negative }}</b-badge
                >
              </h5>
            </div>
          </b-col>

          <!-- <b-col md="4" cols="12">
                        <br>
                    </b-col>
                    <b-col md="4" cols="6">
                        <p class="text-muted text-start font-weight-bold">{{ $t('common.this-sums-based-on-the-selected-date') }}
                        </p>
                    </b-col> -->
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <!-- <b-button variant="primary" @click="getBloodBottles()">
              {{ $t("bloodBank.filter_statistics") }}
            </b-button> -->
            <b-button
              variant="primary"
              @click="searchBloodBottlesAndBalances()"
            >
              {{ $t("common.search") }}
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                            {{ $t("surgery.Print-Hospital-Expenses") }}
                        </b-button> -->
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("bloodBank.boold-boottle-table") }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("bloodBank.add-boold-boottle") }}
          </b-button>
        </div>
        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(status)="data">
            <b-badge
              v-if="
                data.item.status == 'available' &&
                data.item.disposed_at === null
              "
              variant="success"
              style="font-size: 1rem; color: #000"
              >{{ data.item.status }}</b-badge
            >
            <b-badge
              v-else-if="
                data.item.status == 'dispensed' &&
                data.item.disposed_at === null
              "
              variant="danger"
              style="font-size: 1rem; color: #000"
              >{{ data.item.status }}</b-badge
            >
            <b-badge
              v-else-if="data.item.disposed_at !== null"
              variant="warning"
              style="font-size: 1rem; color: #000"
              >Disposed</b-badge
            >
          </template>
          <template #cell(bottle_identifier)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.bottle_identifier }}
            </p>
          </template>
          <template #cell(abo)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.abo }}
            </p>
          </template>
          <template #cell(rh)="data">
            <p style="font-size: 1.2rem; font-weight: bold">
              {{ data.item.rh }}
            </p>
          </template>
          <template #cell(production_date)="data">
            <p style="font-size: 1.2rem; text-wrap: nowrap; font-weight: bold">
              {{ data.item.production_date }}
            </p>
          </template>
          <template #cell(expiration_date)="data">
            <b-badge
              :variant="getExpiryBadgeVariant(data.item.expiration_date)"
              style="font-size: 16px; color: #000"
            >
              <!-- <ClockIcon size="1.5x" /> -->
              {{ data.item.expiration_date }}
            </b-badge>
          </template>
          <template #cell(inserted_at)="data">
            <p style="font-size: 1.2rem; text-wrap: nowrap; font-weight: bold">
              {{ data.item.inserted_at }}
            </p>
          </template>
          <template #cell(dispensed_at)="data">
            <div class="d-flex align-items-center">
              <p
                style="font-size: 1.2rem; text-wrap: nowrap; font-weight: bold"
              >
                {{ data.item.dispensed_at }}
              </p>
            </div>
          </template>
          <template #cell(disposed_at)="data">
            <b-button
              v-if="data.item.status !== 'dispensed' && !data.item.disposed_at"
              variant="warning"
              size="sm"
              @click="showDisposeModal(data.item)"
              style="
                font-size: 1.2rem;
                font-weight: bold;
                color: #000 !important;
              "
            >
              {{ $t("bloodBank.dispose") }}
            </b-button>
            <b-button
              v-if="data.item.disposed_at"
              variant="success"
              size="sm"
              :disabled="
                !$store.state.auth.permissions.includes(
                  'assign-permission-to-user'
                )
              "
              @click="showRevertDisposalModal(data.item)"
              style="
                font-size: 1.2rem;
                font-weight: bold;
                color: #000 !important;
                text-wrap: nowrap;
              "
            >
              {{ data.item.disposed_at }}
            </b-button>
          </template>
          <template #cell(dispose_action)="data"> </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="get-bloodBottle"
                editPerm="get-bloodBottle"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBloodBottles()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import { ClockIcon } from "vue-feather-icons";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    ClockIcon,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        bottle_identifier: "",
        abo: "",
        rh: "",
        form_date: "",
        to_date: "",
        _method: "PUT",
        inserted_at: "",
      },
      createMode: false,
      errorForm: {
        bottle_identifier: "",
        abo: "",
        rh: "",
        production_date: "",
        expiration_date: "",
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "bottle_identifier",
          sortable: true,
          label: this.$t("bloodBank.bottle-identifier"),
        },
        {
          key: "abo",
          sortable: true,
          label: this.$t("bloodBank.abo"),
        },
        {
          key: "rh",
          sortable: true,
          label: this.$t("bloodBank.rh"),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("bloodBank.status"),
        },
        {
          key: "production_date",
          sortable: true,
          label: this.$t("bloodBank.prod-date"),
        },
        {
          key: "expiration_date",
          sortable: true,
          label: this.$t("bloodBank.exp-date"),
        },
        {
          key: "inserted_at",
          sortable: true,
          label: this.$t("bloodBank.inserted-at"),
        },
        {
          key: "dispensed_at",
          sortable: true,
          label: this.$t("bloodBank.dispensed-at"),
        },
        // {
        //   key: "dispose_action",
        //   label: this.$t("bloodBank.dispose-action"),
        //   // thStyle: { width: "100px" },
        // },
        {
          key: "disposed_at",
          sortable: true,
          label: this.$t("bloodBank.disposed-at"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
      ],

      aboOptions: ["A", "B", "AB", "O"],
      rhOptions: ["Positive", "Negative"],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      abo: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      bottle_identifier: "",
      inserted_at: "",
      searchFromToBy: [
        {
          key: "created_at",
          label: this.$t("bloodBank.created_at"),
          from: "created_at-ge",
          to: "created_at-le",
        },
        {
          key: "production_date",
          label: this.$t("bloodBank.prod-date"),
          from: "production_date-ge",
          to: "production_date-le",
        },
        {
          key: "expiration_date",
          label: this.$t("bloodBank.exp-date"),
          from: "expiration_date-ge",
          to: "expiration_date-le",
        },
        {
          key: "inserted_at",
          label: this.$t("bloodBank.inserted-at"),
          from: "inserted_at-ge",
          to: "inserted_at-le",
        },
        {
          key: "dispensed_at",
          label: this.$t("bloodBank.dispensed-at"),
          from: "dispensed_at-ge",
          to: "dispensed_at-le",
        },
        {
          key: "reverted_at",
          label: this.$t("bloodBank.reverted-at"),
          from: "reverted_at-ge",
          to: "reverted_at-le",
        },
        {
          key: "disposed_at",
          label: this.$t("bloodBank.disposed-at"),
          from: "disposed_at-ge",
          to: "disposed_at-le",
        },
      ],
      statusOptions: ["available", "dispensed", "disposed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      status: "",
      balances: [],
      bottleToDispose: null,
    };
  },
  mounted() {
    this.getBloodBottles();
    this.getbloodBottlesBalances();
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    async searchBloodBottlesAndBalances() {
      await this.getBloodBottles();
      await this.getbloodBottlesBalances();
    },
    async getbloodBottlesBalances() {
      let url = `/bloodBottlesBalances`;
      if (this.status) {
        url += `?status=${this.status}`;
      }
      const balances = await this.getList(url);
      this.balances = this.transformBalances(balances.data.data);
      console.log("balances", this.balances);
    },
    transformBalances(balances) {
      const result = [];

      balances.forEach((balance) => {
        // Find if the ABO type already exists in the result array
        let existing = result.find((item) => item.abo === balance.abo);

        if (existing) {
          // If it exists, add the RH type and total to it
          existing[balance.rh] = balance.total.toString();
        } else {
          // If it doesn't exist, create a new entry
          const newEntry = {
            abo: balance.abo,
            [balance.rh]: balance.total.toString(),
          };
          result.push(newEntry);
        }
      });

      return result;
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.bottle_identifier = item.bottle_identifier;
        this.EditForm.abo = item.abo;
        this.EditForm.rh = item.rh;
        this.EditForm.production_date = item.production_date;
        this.EditForm.expiration_date = item.expiration_date;
        this.EditForm.inserted_at = item.inserted_at;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getBloodBottles() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/bloodBottles?page=${this.page}&take=${
        this.searchDate && (this.from_date || this.to_date) ? 1000 : 15
      }&sort=-id&include[]=bloodTransfusions&include[]=bloodCompatibilities`;

      if (this.bottle_identifier) {
        url += `&filter[bottle_identifier]=${this.bottle_identifier}`;
      }
      if (this.abo) {
        url += `&filter[abo]=${this.abo}`;
      }
      if (this.rh) {
        url += `&filter[rh]=${this.rh}`;
      }
      if (this.from_date) {
        url += `&filter[${this.searchDate.from}]=${this.formatDate(
          this.from_date
        )}`;
      }
      if (this.to_date) {
        url += `&filter[${this.searchDate.to}]=${this.formatDate(
          this.to_date
        )}`;
      }
      if (this.status) {
        url += `&filter[status]=${this.status}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/bloodBottles/${this.deleteForm.id}`)
        .then(async (response) => {
          await this.searchBloodBottlesAndBalances();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " +
                this.deleteForm.bottle_identifier +
                " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.bottle_identifier,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.bottle_identifier = "";
      this.errorForm.abo = "";
      this.errorForm.rh = "";
      this.errorForm.production_date = "";
      this.errorForm.expiration_date = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.bottle_identifier) {
        count++;
        this.errorForm.bottle_identifier =
          "The bottle identifier field is required.";
      }
      if (!this.EditForm.abo) {
        count++;
        this.errorForm.abo = "The ABO field is required.";
      }
      if (!this.EditForm.rh) {
        count++;
        this.errorForm.rh = "The RH field is required.";
      }
      if (!this.EditForm.production_date) {
        count++;
        this.errorForm.production_date =
          "The production date field is required.";
      }
      if (!this.EditForm.expiration_date) {
        count++;
        this.errorForm.expiration_date =
          "The expiration date field is required.";
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      this.EditForm.production_date = this.formatDate(
        this.EditForm.production_date
      );
      this.EditForm.expiration_date = this.formatDate(
        this.EditForm.expiration_date
      );
      this.EditForm.inserted_at = this.formatDate(this.EditForm.inserted_at);

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodBottles`),
          this.$store
            .dispatch("create", this.params)
            .then(async (response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              await this.searchBloodBottlesAndBalances();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodBottles/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then(async (response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              await this.searchBloodBottlesAndBalances();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    getExpiryBadgeVariant(expiryDate) {
      const today = new Date();
      const expirationDate = new Date(expiryDate);
      const timeDifference = expirationDate - today;

      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

      console.log(
        `daysDifference: ${daysDifference} expiryDate: ${expiryDate}`
      );
      if (daysDifference > 60) {
        return "success"; // More than 2 months
      } else if (daysDifference > 0 && daysDifference <= 60) {
        return "warning"; // Between today and 2 months
      } else {
        return "danger"; // Today or in the past
      }
    },
    showDisposeModal(bottle) {
      this.bottleToDispose = bottle;
      this.$bvModal.show("modal-dispose");
    },
    async disposeBottle() {
      this.loading = true;
      try {
        await this.$store.dispatch("put", {
          path: `disposeBloodBottle/${this.bottleToDispose.id}`,
          form: {},
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.success"),
            icon: "CheckIcon",
            variant: "success",
            text: this.$t("bloodBank.dispose-success"),
          },
        });

        this.$bvModal.hide("modal-dispose");
        // Refresh the blood bottles list
        await this.searchBloodBottlesAndBalances();
        this.loading = false;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
            text:
              error.response?.data?.message || this.$t("common.error-occurred"),
          },
        });
        this.loading = false;
      }
    },
    showRevertDisposalModal(bottle) {
      this.bottleToDispose = bottle;
      this.$bvModal.show("modal-revert-disposal");
    },
    async revertDisposal() {
      this.loading = true;
      try {
        await this.$store.dispatch("put", {
          path: `revertBloodBottleDisposal/${this.bottleToDispose.id}`,
          form: {},
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.success"),
            icon: "CheckIcon",
            variant: "success",
            text: this.$t("bloodBank.revert-disposal-success"),
          },
        });

        this.$bvModal.hide("modal-revert-disposal");
        // Refresh the blood bottles list
        await this.searchBloodBottlesAndBalances();
        this.loading = false;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
            text:
              error.response?.data?.message || this.$t("common.error-occurred"),
          },
        });
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
